import { render, staticRenderFns } from "./img-text.vue?vue&type=template&id=2411ff86&scoped=true&"
import script from "./img-text.vue?vue&type=script&lang=js&"
export * from "./img-text.vue?vue&type=script&lang=js&"
import style0 from "./img-text.vue?vue&type=style&index=0&id=2411ff86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2411ff86",
  null
  
)

export default component.exports